if (!customElements.get('nc-hero-slideshow')) {
  customElements.define('nc-hero-slideshow', class extends HTMLElement {
    connectedCallback() {
      window.clearTimeout(this.timer);
      this.abort?.abort();
      this.observer?.disconnect();
      this.slides = [...this.querySelectorAll('.nc-art-slideshow__slide')];
      if (this.slides.length < 2) return;
      this.index = 0;
      this.interval = Number(this.dataset.interval) || 7000;
      this.paused = this.dataset.autoplay !== 'true';
      this.visible = false;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.buttons = [...this.querySelectorAll('[data-slide]')];
      this.toggle = this.querySelector('[data-toggle]');
      this.controls = this.querySelector('.nc-art-slideshow__controls');
      this.controls.hidden = false;
      this.buttons.forEach(button => button.addEventListener('click', () => {
        this.paused = true;
        this.show(Number(button.dataset.slide));
      }, options));
      this.toggle.addEventListener('click', () => {
        this.paused = !this.paused;
        this.sync();
      }, options);
      this.addEventListener('focusin', event => {
        if (event.target === this.toggle && !this.toggle.matches(':focus-visible')) return;
        this.paused = true;
        this.sync();
      }, options);
      this.controls.addEventListener('mouseenter', () => { this.hovering = true; this.schedule(); }, options);
      this.controls.addEventListener('mouseleave', () => { this.hovering = false; this.schedule(); }, options);
      this.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch' && !event.target.closest('button')) this.touch = { x: event.clientX, y: event.clientY };
      }, options);
      this.addEventListener('pointerup', event => {
        if (!this.touch) return;
        const dx = event.clientX - this.touch.x;
        const dy = event.clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) {
          this.paused = true;
          this.show(this.index + (dx < 0 ? 1 : -1));
        }
      }, options);
      this.addEventListener('pointercancel', () => { this.touch = null; }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => this.sync(), options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
        if (index >= 0) { this.paused = true; this.show(index); }
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: 0.01 });
      this.observer.observe(this);
      this.sync();
    }

    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
        if (active && slide.querySelector('img')) slide.querySelector('img').loading = 'eager';
      });
      this.buttons.forEach((button, i) => {
        if (i === this.index) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      this.sync();
    }

    sync() {
      this.toggle.hidden = this.motion.matches;
      this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
      this.toggle.querySelector('[data-play-icon]').hidden = !this.paused;
      this.toggle.querySelector('[data-pause-icon]').hidden = this.paused;
      this.schedule();
    }

    schedule() {
      window.clearTimeout(this.timer);
      if (this.paused || this.motion.matches || !this.visible || document.hidden || this.hovering) return;
      this.timer = window.setTimeout(() => this.show(this.index + 1), this.interval);
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}
